import { JSX } from 'react'

import { IconProps } from '../../icon'

const EdubookLandscapeGradient: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 35}
    id={id}
    stroke={stroke}
    viewBox='0 0 111 35'
    width={width || 111}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M79.4595 34.9953L79.4798 35L79.4827 34.9899L102.803 29.6091L101.847 26.3136L79.4597 31.4693L57.0822 26.3136L56.1261 29.6091L79.4362 34.9899L79.4391 35L79.4595 34.9953Z'
      fill='url(#paint0_linear_2208_4769)'
    />
    <path
      d='M4.07877 3.61087H13.823L13.2636 0.742523H0V3.61087H4.07877Z'
      fill='url(#paint1_linear_2208_4769)'
    />
    <path
      d='M10.9242 11.6666L10.3342 8.76779H4.07877H0V11.6666H4.07877H10.9242Z'
      fill='url(#paint2_linear_2208_4769)'
    />
    <path
      d='M13.2636 17.0474H4.07877H0V19.8852H13.8535L13.2636 17.0474Z'
      fill='url(#paint3_linear_2208_4769)'
    />
    <path
      d='M28.6937 19.8852H26.7814L25.9372 18.6443C24.737 19.6919 23.4249 20.2209 21.9907 20.2209C19.8648 20.2209 18.1967 19.5801 16.966 18.2883C15.7352 17.0067 15.1249 15.2572 15.1249 13.0602C15.1249 11.6362 15.3996 10.3749 15.959 9.28654C16.5082 8.1982 17.3118 7.35396 18.3696 6.75384C19.4173 6.15373 20.6684 5.84858 22.1127 5.84858C22.5603 5.84858 23.0383 5.92996 23.5469 6.0927C24.0555 6.25545 24.5437 6.46904 25.0116 6.75384V0.305139L28.7038 0V19.875L28.6937 19.8852ZM22.1331 17.0982C22.6213 17.0982 23.0994 17.0067 23.5571 16.8134C24.0148 16.6303 24.503 16.3455 25.0116 15.9692V10.1409C24.5234 9.72391 24.0555 9.42894 23.6079 9.25603C23.1604 9.07294 22.6722 8.99158 22.1432 8.99158C21.1464 8.99158 20.3632 9.36792 19.7733 10.1308C19.1935 10.8936 18.8985 11.8701 18.8985 13.0703C18.8985 14.2706 19.1833 15.247 19.7529 15.9895C20.3225 16.732 21.1159 17.0982 22.1331 17.0982Z'
      fill='url(#paint4_linear_2208_4769)'
    />
    <path
      d='M37.5937 17.2915C38.2345 17.2915 38.8346 17.1491 39.394 16.8541C39.9535 16.5591 40.5739 16.1726 41.2554 15.6844V6.22495H44.9171V19.8852H42.5268L41.9064 18.4205C41.0621 19.0206 40.1569 19.4885 39.2008 19.8242C38.2447 20.1598 37.3903 20.3328 36.6376 20.3328C34.9084 20.3328 33.698 19.8445 33.0064 18.8681C32.3147 17.8916 31.9689 16.5286 31.9689 14.7893V6.22495H35.6306V14.6164C35.6306 15.4606 35.8035 16.1218 36.1493 16.5897C36.4952 17.0576 36.9834 17.2915 37.6039 17.2915H37.5937Z'
      fill='url(#paint5_linear_2208_4769)'
    />
    <path
      d='M72.1665 20.2209C70.7018 20.2209 69.4202 19.9259 68.3217 19.3461C67.2232 18.7663 66.379 17.9323 65.7687 16.8541C65.1686 15.7759 64.8634 14.5147 64.8634 13.0703C64.8634 11.626 65.1584 10.3545 65.7687 9.2662C66.3688 8.17785 67.2232 7.33362 68.3217 6.74368C69.4202 6.15373 70.7018 5.85876 72.1665 5.85876C73.6312 5.85876 74.9128 6.15374 76.0114 6.73351C77.1099 7.31328 77.9541 8.14734 78.5644 9.22552C79.1645 10.3037 79.4697 11.565 79.4697 13.0093C79.4697 14.4536 79.1645 15.7251 78.5644 16.8134C77.9643 17.9018 77.1099 18.746 76.0114 19.336C74.9128 19.9259 73.6312 20.2209 72.1665 20.2209ZM75.6859 13.0093C75.6859 11.8294 75.3604 10.8631 74.6992 10.1104C74.0381 9.35774 73.1939 8.9814 72.1665 8.9814C71.1392 8.9814 70.3153 9.36792 69.644 10.1308C68.9727 10.9038 68.6472 11.8803 68.6472 13.0602C68.6472 14.2401 68.9727 15.2063 69.6339 15.959C70.295 16.7117 71.1392 17.0881 72.1665 17.0881C73.1939 17.0881 74.0178 16.7015 74.6891 15.9285C75.3502 15.1555 75.6859 14.179 75.6859 12.9991V13.0093Z'
      fill='url(#paint6_linear_2208_4769)'
    />
    <path
      d='M88.1662 20.2209C86.7015 20.2209 85.4199 19.9259 84.3214 19.3461C83.2229 18.7663 82.3787 17.9323 81.7684 16.8541C81.1683 15.7759 80.8631 14.5147 80.8631 13.0703C80.8631 11.626 81.1581 10.3545 81.7684 9.2662C82.3685 8.17785 83.2229 7.33362 84.3214 6.74368C85.4199 6.15373 86.7015 5.85876 88.1662 5.85876C89.6309 5.85876 90.9125 6.15374 92.011 6.73351C93.1096 7.31328 93.9538 8.14734 94.5641 9.22552C95.1642 10.3037 95.4694 11.565 95.4694 13.0093C95.4694 14.4536 95.1642 15.7251 94.5641 16.8134C93.964 17.9018 93.1096 18.746 92.011 19.336C90.9125 19.9259 89.6309 20.2209 88.1662 20.2209ZM91.6856 13.0093C91.6856 11.8294 91.3601 10.8631 90.6989 10.1104C90.0378 9.35774 89.1935 8.9814 88.1662 8.9814C87.1389 8.9814 86.315 9.36792 85.6437 10.1308C84.9724 10.9038 84.6469 11.8803 84.6469 13.0602C84.6469 14.2401 84.9724 15.2063 85.6335 15.959C86.2947 16.7117 87.1389 17.0881 88.1662 17.0881C89.1935 17.0881 90.0174 16.7015 90.6888 15.9285C91.3499 15.1555 91.6856 14.179 91.6856 12.9991V13.0093Z'
      fill='url(#paint7_linear_2208_4769)'
    />
    <path
      d='M101.176 15.4098V19.8852H97.5443V0.315332L101.176 0.0101929V11.2191L107.034 5.83844L109.089 8.43216L105.264 11.7786L110.279 19.8852H106.078L102.64 14.1078L101.176 15.3996V15.4098Z'
      fill='url(#paint8_linear_2208_4769)'
    />
    <path
      d='M60.5101 9.50015C61.8832 8.43215 62.5647 7.29294 62.5647 6.09271C62.5647 4.25167 62.0154 2.89886 60.9067 2.03429C59.798 1.16971 58.2621 0.742523 56.2889 0.742523H48.8535V3.78378H55.7498C56.7263 3.78378 57.4586 3.96687 57.957 4.32287C58.4554 4.67887 58.6995 5.28916 58.6995 6.15373C58.6995 6.94711 58.3842 7.53706 57.7434 7.94392C57.1026 8.35078 56.2482 8.5542 55.1802 8.5542H48.8434V11.5141H56.6754C57.5908 11.5141 58.3232 11.7582 58.8623 12.2464C59.4014 12.7347 59.6658 13.4162 59.6658 14.3011C59.6658 15.125 59.3708 15.7658 58.7911 16.2133C58.2113 16.6609 57.4179 16.8846 56.4211 16.8846H48.8434V19.8954H56.6958C58.7606 19.8954 60.3982 19.397 61.6187 18.39C62.8393 17.383 63.4496 16.0099 63.4496 14.2604C63.4496 12.1244 62.463 10.5376 60.4897 9.50015H60.5101Z'
      fill='url(#paint9_linear_2208_4769)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2208_4769'
        x1='2.68523'
        y1='-1.53587'
        x2='103.769'
        y2='35.4578'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2208_4769'
        x1='1.95292'
        y1='0.467893'
        x2='103.037'
        y2='37.4616'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_2208_4769'
        x1='-0.813718'
        y1='8.02528'
        x2='100.26'
        y2='45.019'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_2208_4769'
        x1='-3.30573'
        y1='14.83'
        x2='97.7783'
        y2='51.8237'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_2208_4769'
        x1='1.51553'
        y1='1.67829'
        x2='102.589'
        y2='38.6719'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_2208_4769'
        x1='2.32924'
        y1='-0.569589'
        x2='103.413'
        y2='36.4342'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_2208_4769'
        x1='6.19444'
        y1='-11.1072'
        x2='107.268'
        y2='25.8864'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_2208_4769'
        x1='8.07606'
        y1='-16.2642'
        x2='109.16'
        y2='20.7295'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_2208_4769'
        x1='10.4053'
        y1='-22.6111'
        x2='111.479'
        y2='14.3826'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_2208_4769'
        x1='4.86198'
        y1='-7.47602'
        x2='105.936'
        y2='29.5176'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
    </defs>
  </svg>
)

export default EdubookLandscapeGradient
